import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './home.css'

const Home = (props) => {
  return (
    <div className="home-container1">
      <Helmet>
        <title>Ketame</title>
        <meta property="og:title" content="Ketame" />
        <link
          rel="canonical"
          href="https://ketame.me/"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="hero-episode">
        <div className="hero-episode-wrapper">
          <div className="hero-episode-media">
            <img
              src="https://images.pexels.com/photos/34344551/pexels-photo-34344551.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              alt="Mike the Blue Horse in a Neon Meadow"
              className="hero-episode-img"
            />
            <div className="hero-episode-overlay"></div>
          </div>
          <div className="hero-episode-content">
            <span className="hero-episode-tag">Latest Episode #142</span>
            <h1 className="hero-title">
              The Blue Horse and the Quantum Sugar Cube
            </h1>
            <p className="hero-subtitle">
              Mike discovers a sugar cube that exists in four dimensions
              simultaneously. Things get sticky across space-time in this
              week&apos;s absurd adventure.
            </p>
            <div className="hero-episode-actions">
              <a href="#">
                <div className="btn btn-primary btn-xl">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
                    <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
                  </svg>
                  <span>Read Episode Now</span>
                </div>
              </a>
              <a href="#">
                <div className="btn btn-xl btn-outline">
                  <span>View Archive</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <section className="meme-gallery">
        <div className="meme-gallery-header">
          <h2 className="section-title">Fresh Meme Panels</h2>
          <p className="section-content">
            Quick bites of absurdity for your daily scroll.
          </p>
        </div>
        <div className="meme-gallery-grid">
          <div className="meme-card">
            <img
              src="https://images.pexels.com/photos/7313450/pexels-photo-7313450.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              alt="Meme 1"
              className="meme-img"
            />
            <div className="meme-info">
              <span className="meme-label">Relatable</span>
            </div>
          </div>
          <div className="meme-card">
            <img
              src="https://images.pexels.com/photos/11798029/pexels-photo-11798029.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              alt="Meme 2"
              className="meme-img"
            />
            <div className="meme-info">
              <span className="meme-label">Surreal</span>
            </div>
          </div>
          <div className="meme-card">
            <img
              src="https://images.pexels.com/photos/137595/pexels-photo-137595.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              alt="Meme 3"
              className="meme-img"
            />
            <div className="meme-info">
              <span className="meme-label">Classic Mike</span>
            </div>
          </div>
          <div className="meme-card">
            <img
              src="https://images.pexels.com/photos/3905773/pexels-photo-3905773.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              alt="Meme 4"
              className="meme-img"
            />
            <div className="meme-info">
              <span className="meme-label">Deep Thoughts</span>
            </div>
          </div>
          <div className="meme-card">
            <img
              src="https://images.pexels.com/photos/8832238/pexels-photo-8832238.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              alt="Meme 5"
              className="meme-img"
            />
            <div className="meme-info">
              <span className="meme-label">Mood</span>
            </div>
          </div>
          <div className="meme-card">
            <img
              src="https://images.pexels.com/photos/6897771/pexels-photo-6897771.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              alt="Meme 6"
              className="meme-img"
            />
            <div className="meme-info">
              <span className="meme-label">Absurd</span>
            </div>
          </div>
        </div>
      </section>
      <section className="series-showcase">
        <div className="series-header">
          <h2 className="section-title">Explore the Multiverse</h2>
          <p className="section-content">
            Dive deep into our recurring storylines and bizarre sagas.
          </p>
        </div>
        <div className="series-grid">
          <article className="series-item">
            <div className="series-thumb-wrapper">
              <img
                src="https://images.pexels.com/photos/7946450/pexels-photo-7946450.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                alt="The Rainbow Gallop"
                className="series-thumb"
              />
            </div>
            <div className="series-details">
              <h3 className="section-subtitle">The Rainbow Gallop</h3>
              <p className="section-content">
                Mike accidentally eats a prism and starts leaving trails of pure
                color everywhere he goes.
              </p>
              <a href="#">
                <div className="btn btn-link">
                  <span>Browse Arc</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M5 12h14m-7-7l7 7l-7 7"></path>
                  </svg>
                </div>
              </a>
            </div>
          </article>
          <article className="series-item">
            <div className="series-thumb-wrapper">
              <img
                src="https://images.pexels.com/photos/16516/pexels-photo.jpg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                alt="City of Doodles"
                className="series-thumb"
              />
            </div>
            <div className="series-details">
              <h3 className="section-subtitle">City of Doodles</h3>
              <p className="section-content">
                Our heroes find themselves trapped in a world where the laws of
                physics are dictated by a toddler&apos;s crayon.
              </p>
              <a href="#">
                <div className="btn btn-link">
                  <span>Browse Arc</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M5 12h14m-7-7l7 7l-7 7"></path>
                  </svg>
                </div>
              </a>
            </div>
          </article>
          <article className="series-item">
            <div className="series-thumb-wrapper">
              <img
                src="https://images.pexels.com/photos/6664553/pexels-photo-6664553.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                alt="Paper Kingdom"
                className="series-thumb"
              />
            </div>
            <div className="series-details">
              <h3 className="section-subtitle">The Paper Kingdom</h3>
              <p className="section-content">
                A 2D epic where folding yourself is the only way to travel
                across the vast desktop ocean.
              </p>
              <a href="#">
                <div className="btn btn-link">
                  <span>Browse Arc</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M5 12h14m-7-7l7 7l-7 7"></path>
                  </svg>
                </div>
              </a>
            </div>
          </article>
          <article className="series-item">
            <div className="series-thumb-wrapper">
              <img
                src="https://images.pexels.com/photos/30171894/pexels-photo-30171894.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                alt="Surreal Dreams"
                className="series-thumb"
              />
            </div>
            <div className="series-details">
              <h3 className="section-subtitle">Noon-Day Nightmares</h3>
              <p className="section-content">
                What happens when the sun takes a lunch break? Mike has to find
                a way to turn the lights back on.
              </p>
              <a href="#">
                <div className="btn btn-link">
                  <span>Browse Arc</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M5 12h14m-7-7l7 7l-7 7"></path>
                  </svg>
                </div>
              </a>
            </div>
          </article>
          <article className="series-item">
            <div className="series-thumb-wrapper">
              <img
                src="https://images.pexels.com/photos/6593335/pexels-photo-6593335.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                alt="Cat Umbrella"
                className="series-thumb"
              />
            </div>
            <div className="series-details">
              <h3 className="section-subtitle">The Rain of Felines</h3>
              <p className="section-content">
                It&apos;s literally raining cats. Mike needs a very big umbrella
                and a lot of tuna.
              </p>
              <a href="#">
                <div className="btn btn-link">
                  <span>Browse Arc</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M5 12h14m-7-7l7 7l-7 7"></path>
                  </svg>
                </div>
              </a>
            </div>
          </article>
          <article className="series-item">
            <div className="series-thumb-wrapper">
              <img
                src="https://images.pexels.com/photos/788587/pexels-photo-788587.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                alt="Space Dog"
                className="series-thumb"
              />
            </div>
            <div className="series-details">
              <h3 className="section-subtitle">Interstellar Bark</h3>
              <p className="section-content">
                Mike&apos;s best friend, Cosmo the Space Dog, gets lost in a
                black hole of treats.
              </p>
              <a href="#">
                <div className="btn btn-link">
                  <span>Browse Arc</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M5 12h14m-7-7l7 7l-7 7"></path>
                  </svg>
                </div>
              </a>
            </div>
          </article>
        </div>
      </section>
      <section className="character-features">
        <div className="character-header">
          <h2 className="section-title">The Cast of Chaos</h2>
        </div>
        <div id="characterCarousel" className="character-carousel-container">
          <div className="character-track">
            <div className="character-card">
              <div className="character-img-box">
                <img
                  src="https://images.pexels.com/photos/2315712/pexels-photo-2315712.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Mike the Blue Horse"
                  className="character-img"
                />
              </div>
              <div className="character-info">
                <h3 className="section-subtitle">Mike the Blue Horse</h3>
                <p className="character-quote">
                  &quot;I don&apos;t need sleep, I need answers about where my
                  left hoof went.&quot;
                </p>
                <a href="#">
                  <div className="btn btn-accent btn-sm">
                    <span>Full Bio</span>
                  </div>
                </a>
              </div>
            </div>
            <div className="character-card">
              <div className="character-img-box">
                <img
                  src="https://images.pexels.com/photos/16566217/pexels-photo-16566217.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="The Miniature Suit Man"
                  className="character-img"
                />
              </div>
              <div className="character-info">
                <h3 className="section-subtitle">Sir Tiny</h3>
                <p className="character-quote">
                  &quot;Business is booming, but I&apos;m only three inches
                  tall.&quot;
                </p>
                <a href="#">
                  <div className="btn btn-accent btn-sm">
                    <span>Full Bio</span>
                  </div>
                </a>
              </div>
            </div>
            <div className="character-card">
              <div className="character-img-box">
                <img
                  src="https://images.pexels.com/photos/994172/pexels-photo-994172.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Cat Mermaid"
                  className="character-img"
                />
              </div>
              <div className="character-info">
                <h3 className="section-subtitle">Meow-Maid</h3>
                <p className="character-quote">
                  &quot;The ocean is just one giant bowl of milk if you believe
                  hard enough.&quot;
                </p>
                <a href="#">
                  <div className="btn btn-accent btn-sm">
                    <span>Full Bio</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div className="carousel-controls">
            <button id="prevChar" className="carousel-btn prev">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="m15 18-6-6 6-6"></path>
              </svg>
            </button>
            <button id="nextChar" className="carousel-btn next">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="m9 18 6-6-6-6"></path>
              </svg>
            </button>
          </div>
        </div>
      </section>
      <section className="random-panel-section">
        <div className="random-panel-container">
          <div className="random-panel-card">
            <div className="random-panel-header">
              <div className="flex-row">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="m18 14 4 4-4 4m0-20 4 4-4 4"></path>
                  <path d="M2 18h1.973a4 4 0 0 0 3.3-1.7l5.454-8.6a4 4 0 0 1 3.3-1.7H22M2 6h1.972a4 4 0 0 1 3.6 2.2M22 18h-6.041a4 4 0 0 1-3.3-1.8l-.359-.45"></path>
                </svg>
                <h2 className="section-subtitle">Random Moment of Zenith</h2>
              </div>
              <button id="shuffleBtn" className="btn btn-outline btn-sm">
                Shuffle
              </button>
            </div>
            <div className="random-panel-body">
              <img
                src="https://images.pexels.com/photos/5545734/pexels-photo-5545734.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                alt="Random Panel"
                id="panelImg"
                className="random-panel-img"
              />
            </div>
            <div className="random-panel-footer">
              <p className="section-content">
                <span>
                  From the episode:
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <span className="home-text22">
                  &quot;The Ghost of Breakfast Past&quot;
                </span>
              </p>
              <a href="#">
                <div className="btn btn-link btn-sm">
                  <span>Read Story</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <section className="subscribe-cta">
        <div className="subscribe-card">
          <div className="subscribe-visual">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="64"
              height="64"
              viewBox="0 0 24 24"
              fill="none"
              stroke="var(--color-primary)"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09m8.445-7.188L18 9.75l-.259-1.035a3.38 3.38 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.38 3.38 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.38 3.38 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.38 3.38 0 0 0-2.456 2.456m-1.365 11.852L16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183l.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394l-1.183.394a2.25 2.25 0 0 0-1.423 1.423"></path>
            </svg>
          </div>
          <div className="subscribe-content">
            <h2 className="section-title">Stay Weird, Mike.</h2>
            <p className="section-content">
              Get new episodes, exclusive meme-panels, and horse-flavored
              existential dread delivered straight to your inbox.
            </p>
            <form
              action="/subscribe"
              method="POST"
              data-form-id="1da6bb92-d8a5-4d75-96c0-ee9f9c7fa499"
              className="subscribe-form"
            >
              <div className="input-group">
                <input
                  type="email"
                  placeholder="horse_lover@stable.com"
                  required="true"
                  id="thq_textinput_Heev"
                  name="textinput"
                  data-form-field-id="thq_textinput_Heev"
                  className="subscribe-input"
                />
                <button
                  type="submit"
                  id="thq_button_kXXh"
                  name="button"
                  data-form-field-id="thq_button_kXXh"
                  className="btn btn-primary"
                >
                  Sign Me Up
                </button>
              </div>
            </form>
            <div className="subscribe-alt">
              <a href="#">
                <div className="btn btn-link btn-sm">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M4 11a9 9 0 0 1 9 9M4 4a16 16 0 0 1 16 16"></path>
                    <circle cx="5" cy="19" r="1"></circle>
                  </svg>
                  <span>RSS Feed</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <section className="archive-bento">
        <div className="archive-bento-grid">
          <div className="bento-cell side-cell">
            <div className="bento-content">
              <h3 className="section-subtitle">Categories</h3>
              <ul className="tag-list">
                <li>
                  <a href="#">
                    <div className="tag-link">
                      <span>Sci-Fi Shenanigans</span>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <div className="tag-link">
                      <span>Existential Crisis</span>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <div className="tag-link">
                      <span>Barnyard Drama</span>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <div className="tag-link">
                      <span>Meme Panels</span>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="bento-cell main-cell">
            <div className="bento-media">
              <img
                src="https://images.pexels.com/photos/218444/pexels-photo-218444.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                alt="Archive Showcase"
                className="bento-img"
              />
              <div className="bento-overlay">
                <h2 className="section-title">The Vault</h2>
                <p className="section-content">
                  Over 500 episodes of pure, unadulterated nonsense.
                </p>
                <a href="#">
                  <div className="btn btn-accent btn-lg">
                    <span>Deep Dive Archive</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div className="bento-cell side-cell">
            <div className="bento-content">
              <h3 className="section-subtitle">Hot Tags</h3>
              <div className="cloud-tags">
                <a href="#">
                  <div className="chip">
                    <span>#Quantum</span>
                  </div>
                </a>
                <a href="#">
                  <div className="chip">
                    <span>#Hay</span>
                  </div>
                </a>
                <a href="#">
                  <div className="chip">
                    <span>#Mike</span>
                  </div>
                </a>
                <a href="#">
                  <div className="chip">
                    <span>#Absurd</span>
                  </div>
                </a>
                <a href="#">
                  <div className="chip">
                    <span>#Surreal</span>
                  </div>
                </a>
                <a href="#">
                  <div className="chip">
                    <span>#BlueHorse</span>
                  </div>
                </a>
                <a href="#">
                  <div className="chip">
                    <span>#Wiggly</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="home-container2">
        <div className="home-container3">
          <Script
            html={`<script defer data-name="ketame-interactions">
(function(){
  // Character Carousel Logic
  const track = document.querySelector('.character-track');
  const nextBtn = document.getElementById('nextChar');
  const prevBtn = document.getElementById('prevChar');

  if (track && nextBtn && prevBtn) {
    nextBtn.addEventListener('click', () => {
      track.scrollBy({ left: 350, behavior: 'smooth' });
    });

    prevBtn.addEventListener('click', () => {
      track.scrollBy({ left: -350, behavior: 'smooth' });
    });
  }

  // Random Panel Shuffle Logic
  const shuffleBtn = document.getElementById('shuffleBtn');
  const panelImg = document.getElementById('panelImg');
  
  const panels = [
    'https://images.pexels.com/photos/5545734/pexels-photo-5545734.jpeg?auto=compress&cs=tinysrgb&h=600&w=800',
    'https://images.pexels.com/photos/16516/pexels-photo.jpg?auto=compress&cs=tinysrgb&h=600&w=800',
    'https://images.pexels.com/photos/7313450/pexels-photo-7313450.jpeg?auto=compress&cs=tinysrgb&h=600&w=800',
    'https://images.pexels.com/photos/11798029/pexels-photo-11798029.jpeg?auto=compress&cs=tinysrgb&h=600&w=800'
  ];

  if (shuffleBtn && panelImg) {
    shuffleBtn.addEventListener('click', () => {
      panelImg.style.opacity = '0.5';
      setTimeout(() => {
        const randomPanel = panels[Math.floor(Math.random() * panels.length)];
        panelImg.src = randomPanel;
        panelImg.style.opacity = '1';
      }, 300);
    });
  }

  // Simple intersection observer for reveal animations
  const observerOptions = {
    threshold: 0.1
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
      }
    });
  }, observerOptions);

  document.querySelectorAll('.series-item, .meme-card, .character-card').forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = 'all 0.6s ease-out';
    observer.observe(el);
  });
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default Home
